import { render, staticRenderFns } from "./Grid.template.vue?vue&type=template&id=52dbff6c&scoped=true&"
var script = {}
import style0 from "./Grid.template.vue?vue&type=style&index=0&id=52dbff6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbff6c",
  null
  
)

export default component.exports